import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Filter from './Filter';
import request from '../../../utils/request';
import getPrettyError from '../../../utils/getPrettyError';
import useEventCallback from '../../../utils/hooks/useEventCallback';
var FLAGS = {
  ContactProperties: 1 << 0,
  AccountProperties: 1 << 1,
  ListsProperties: 1 << 2,
  EngagementProperties: 1 << 3,
  TrackingProperties: 1 << 4,
  ContactAccountProperties: 1 << 5,
  Events: 1 << 6
};
/**
 * @param {import('./types').EcrionFilterSchemaType} schemaType
 */

var getFlag = function getFlag(schemaType) {
  if (schemaType === 'ListCriteria') {
    return FLAGS.ContactProperties + FLAGS.ListsProperties + FLAGS.EngagementProperties + FLAGS.ContactAccountProperties + FLAGS.Events;
  }

  return 0;
};
/**
 * @param {import('./types').FormInputFilterProps} schemaType
 */


var useSchema = function useSchema(_ref) {
  var schemaType = _ref.schemaType,
      onLoaded = _ref.onLoaded,
      onError = _ref.onError;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      schema = _React$useState2[0],
      setSchema = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  var _React$useState5 = React.useState(''),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  React.useEffect(function () {
    setLoading(true);
    request({
      url: '/backend/criterias',
      query: {
        flag: getFlag(schemaType)
      }
    }).then(function (res) {
      setSchema(res);
      setLoading(false);
      if (onLoaded) onLoaded();
    }).catch(function (error) {
      setError(getPrettyError(error));
      setLoading(false);
      if (onError) onError();
    });
  }, [schemaType]);
  return {
    error: error,
    loading: loading,

    /** @type {import('./types').EcrionFilterSchema} */
    schema: schema
  };
};
/**
 * @param {import('./types').FormInputFilterProps } props
 */


var FilterAdapter = function FilterAdapter(props) {
  var _useSchema = useSchema(props),
      loading = _useSchema.loading,
      error = _useSchema.error,
      schema = _useSchema.schema;

  var onChange = useEventCallback(function (newValueFn) {
    var newValue = typeof newValueFn === 'function' ? newValueFn(props.value) : newValueFn;
    return props.onChange(newValue);
  });
  if (loading) return React.createElement("div", null, "Loading...");
  if (error) return React.createElement("div", null, error);
  return React.createElement(Filter, Object.assign({
    schema: schema
  }, props, {
    onChange: onChange
  }));
};

FilterAdapter.defaultProps = {
  schemaType: 'ListCriteria'
};
export default FilterAdapter;